import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import ButtonSection from '../ProjectCreate/ButtonSection';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';

const CreateNewClothForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    ClothQuantity: '',
    ClothSize: '1',
    ClothPrice: '',
    Gender: '1',
    securityCharges: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const payload = {
      ClothId: 0,
      ClothQuantity: parseInt(formData.ClothQuantity),
      ClothImage: "",
      ClothSize: parseInt(formData.ClothSize),
      ClothPrice: parseFloat(formData.ClothPrice),
      securityCharges: parseInt(formData.securityCharges),
      Gender: parseInt(formData.Gender),
      IsLocked: true,
    };
    // Validate form data
    if (!formData.ClothQuantity || !formData.ClothSize || !formData.ClothPrice || !formData.securityCharges || !formData.Gender) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please fill all the required fields.',
      });
      return; // Stop submission if validation fails
    }
    if (isNaN(payload.ClothQuantity) || payload.ClothQuantity <= 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Cloth quantity must be a positive number.',
      });
      return; // Stop submission if validation fails
    }
    if (isNaN(payload.ClothPrice) || payload.ClothPrice <= 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Cloth price must be a positive number.',
      });
      return; // Stop submission if validation fails
    }
    if (isNaN(payload.securityCharges) || payload.securityCharges <= 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Security charges must be a positive number.',
      });
      return; // Stop submission if validation fails
    }
    
    try {
      const response = await api.post('/api/ClothMaster/AddClothMaster', payload, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
  
      if (response.status === 200 || response.status === 201) {
  
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Cloth Created successfully.',
        }).then(() => {
          navigate(`${process.env.PUBLIC_URL}/cloth/clothList`);
        });
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Unexpected Response',
          text: 'Please try again later.',
        });
      }
      // console.log("API Success:", response.data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="theme-form">
      <Row>
        <Col sm="4">
          <FormGroup>
            <Label>Cloth Quantity</Label>
            <input
              name="ClothQuantity"
              type="text"
              className="form-control"
              placeholder="Enter cloth quantity here..."
              value={formData.ClothQuantity}
              onChange={handleChange}
              required={true}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Cloth Size</Label>
            <select
              name="ClothSize"
              className="form-control form-select"
              value={formData.ClothSize}
              onChange={handleChange}
              required={true}
            >
              <option value="1">Small(S)</option>
              <option value="2">Medium(M)</option>
              <option value="3">Large(L)</option>
              <option value="4">Extra Large(XL)</option>
              <option value="5">XXL</option>

            </select>
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Gender</Label>
            <select
              name="Gender"
              className="form-control form-select"
              value={formData.Gender}
              onChange={handleChange}
              required={true}
            >
              <option value="1">Male</option>
              <option value="2">Female</option>
              <option value="3">Baby Swim Suit</option>
            </select>
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Cloth Price</Label>
            <input
              name="ClothPrice"
              type="text"
              className="form-control"
              placeholder="Enter per cloth price ..."
              value={formData.ClothPrice}
              onChange={handleChange}
              required={true}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
              <Label check>Security Charge</Label>
              <input
              name="securityCharges"
              type="text"
              className="form-control"
              placeholder="Enter per security charge ..."
              value={formData.securityCharges}
              onChange={handleChange}
              required={true}
            />
          </FormGroup>
          </Col>
      </Row>
      <ButtonSection cancel_url={`/cloth/clothList`} />
    </form>
  );
};

export default CreateNewClothForm;
